export default __webpack_public_path__ + "static/media/arrow_slider.8c329e47.svg";